import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'

import Box from '@material-ui/core/Box'
import Markdown from '../ui/Markdown'
import Button from '../ui/Button'
import Fade from 'react-reveal/Fade';

import useMediaQuery from '@material-ui/core/useMediaQuery'
import Circle from 'react-circle';

const styles = theme => ({
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    //    padding: theme.spacing(0, 3),
    },    
    btnStyle: { 
      textTransform: 'none', 
      fontSize: theme.typography.h6.fontSize 
    },
    btnTitle:{
      zIndex: 1
    }
})

const ProgressContentBlock = ({classes, theme, openLink, children, title, subtitle, body, images, color, color_type, image_width, image_position, text_alignment, button_title, button_style, link_to, item_spacing}) => {  
  let imageUrl = null
  let imageStyle = []
  let itemStyle = []

  let smUp = useMediaQuery(theme.breakpoints.up('sm'))

  if (images && images !== undefined && images.length > 0) {
    imageStyle['width'] = image_width ? image_width+'%' : '100%'
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  if(text_alignment === 'left'){
    itemStyle['alignItems'] = 'flex-start'
  }else if(text_alignment === 'right'){
    itemStyle['alignItems'] = 'flex-end'
  }else{
    itemStyle['alignItems'] = 'center'
  }

  // if(smUp){
  //   itemStyle['padding'] = '0 '+item_spacing+'%'
  // }else{
  //   itemStyle['padding'] = item_spacing+'% 0'
  // }
  let percentage = title ? title.match(/\d/g).join("") : 100

  let textColor
  let progressColor
  let backgroundColor
  let size

  if(color === '#fff'){
    textColor =  '#eee'
    backgroundColor =  '#333'
    progressColor = '#eee'
  }else if(color === '#000'){
    textColor =  '#000'
    backgroundColor =  '#ddd'
    progressColor = '#000'
  }else{
    textColor =  '#fff'
    backgroundColor = '#333'
    progressColor = '#fff'
  }

  if(smUp){
    size = '200'
  }else{
    size = '100'
  }

  return (
    <div className={classes.item} style={itemStyle}>
      
      <Fade>
        <Box align={text_alignment}>
            { title &&
                <Circle
                progress={percentage}
                responsive={false}
                animate={true}
                roundedStroke={false}
                size={size}
                progressColor={progressColor}
                bgColor={backgroundColor}
                textColor={textColor}
                lineWidth={'30'}
                textStyle={{ font: 'bold 5rem Helvetica, Arial, sans-serif' }}
                />
                // <Markdown source={ title } variant='hero' color={color}/>
            }
            { subtitle &&
            <Markdown source={ subtitle } variant='hero' color={color}/>
            }

            {body &&
            <Markdown source={ body } variant='body' color={color}/>
            }

            { imageUrl &&
            <Box mt={4}>
                <img src={imageUrl} className={classes.imageCenter} style={imageStyle}/>
            </Box>
            }
        </Box>
        </Fade>
        
        { children &&
            <Box style={{width:'100%'}}>
            { Array.isArray(children) ?
            <>
            { children.map(c => (c)) }
            </>
            :
            <>
            { children }
            </>
            }
            </Box>
        }      
        
        { link_to && link_to !== undefined &&   
        <Fade>     
            <Box align="center" mt={4}  >
            <Button style={button_style} className={classes.btnTitle} onClick={ () => openLink(link_to) }>
                { button_title }
            </Button>
            </Box>
        </Fade>
        }
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(ProgressContentBlock);

